import { Box, Container, Typography, useTheme } from "@mui/material";
import { heroContent } from "../../data/heroContent";
import { scheduleCallConfig } from "../../data/scheduleCallContent";
import OverlayBackground from "../common/OverlayBackground";
import ScheduleCallButton from "../common/ScheduleCallButton";
import SectionMainTitle from "../common/SectionMainTitle";
import WistiaVideo from "../common/WistiaVideo";

const HeroSection: React.FC = () => {
  const theme = useTheme();

  return (
    <OverlayBackground
      backgroundImage="/assets/hero-bg.jpg"
      overlayColor="rgba(0,0,0,0.6)"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: {
          xs: "auto",
          sm: "auto",
          md: "auto",
          lg: "clamp(800px, 80vh, 900px)",
        },
        pt: { xs: 10, sm: 12, md: 12 },
        pb: { xs: 10, sm: 12, md: 0 },
      }}
    >
      <Container
        maxWidth="lg"
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: "center",
          justifyContent: "space-between",
          textAlign: { xs: "left", md: "left" },
          gap: 3,
        }}
      >
        {/* TEXT SECTION */}
        <Box sx={{ flex: 1, mt: { xs: 2, sm: 0 } }}>
          <SectionMainTitle title={heroContent.hero.headline} align="left" />

          <Typography
            variant="h6"
            sx={{
              color: theme.palette.secondary.main,
              mb: 4,
              fontSize: { xs: "1.0rem", md: "1.25rem" },
              textAlign: { xs: "justify", md: "left" },
            }}
          >
            {heroContent.hero.subheadline}
          </Typography>
          <ScheduleCallButton
            label={scheduleCallConfig.buttonLabel}
            // ghlUrl={scheduleCallConfig.ghlUrl}
          />
        </Box>

        {/* VIDEO SECTION */}

        <Box
          sx={{
            flex: 1,
            width: "100%",
            maxWidth: 460,
            boxShadow: 3,
            borderRadius: 2,
            overflow: "hidden",
          }}
        >
          <WistiaVideo
            mediaId={heroContent.video.wistiaId}
            aspectRatio={1 / 1}
          />
        </Box>
      </Container>
    </OverlayBackground>
  );
};

export default HeroSection;
